/**
 * 트리 컴포넌트에서 사용되는 깊이 관련 상수
 *
 * 도메인 깊이 제한 이유:
 * - OpenMetadata DB의 fqnHash 컬럼이 VARCHAR(255)
 * - fqnHash = 각 계층의 MD5 해시(32자) + 구분자(.)
 * - 7계층: 32*7 + 6 = 230자 (OK)
 * - 8계층: 32*8 + 7 = 263자 (초과!)
 */
export const TREE_DEPTH = {
  /** 용어 카테고리 트리 최대 깊이 */
  GLOSSARY_CATEGORY: 10,
  /** 용어 트리 최대 깊이 */
  GLOSSARY_TERM: 10,
  /** 도메인 트리 최대 깊이 (fqnHash VARCHAR(255) 제한으로 인해 최대 7계층) */
  DOMAIN: 6,
  /** 태그 트리 최대 깊이 */
  TAG: 2,
  /** TreeSelect 컴포넌트 최대 깅이 (관련 용어 선택 등) */
  TREE_SELECT: 2,
} as const;

export type TreeDepthKey = keyof typeof TREE_DEPTH;
